import { render, staticRenderFns } from "./HolidayTemplateCards.vue?vue&type=template&id=0270f296&scoped=true"
import script from "./HolidayTemplateCards.vue?vue&type=script&lang=js"
export * from "./HolidayTemplateCards.vue?vue&type=script&lang=js"
import style0 from "./HolidayTemplateCards.vue?vue&type=style&index=0&id=0270f296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270f296",
  null
  
)

export default component.exports